import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Box, 
  Alert,
  Divider,
  Paper,
  Chip,
  InputAdornment,
  IconButton
} from '@mui/material';
import {   
  Lock as LockIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Google as GoogleIcon, 
  Login as LoginIcon, 
  Coffee as CoffeeIcon 
} from '@mui/icons-material';
import api from '../services/api';
import { API_URL } from '../services/appData'
import { useAuth } from '../context/AuthContext';

const LoginPage = ({keywordsData, language}) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await api.post('/auth/login', formData);
      login(response.data.token, response.data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'فشل تسجيل الدخول');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    setLoading(true);
    setError('');
    window.location.href = `${API_URL}/auth/google`;
  };
  const loginTxt = language === 'ar' ? 'تسجيل الدخول': 'Login';
  const prossessLoginTxt = language === 'ar' ? 'جار تسجيل الدخول...' : 'Login ...'

  return (
    <Container maxWidth="sm" sx={{ 
      py: 6, 
      mb: 10,
      backgroundColor: '#000000',
      minHeight: '100vh',
      color: '#FFFFFF',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Paper sx={{ 
        p: 5,
        width: '100%',
        backgroundColor: '#0D0D0D',
        border: '1px solid #2D2D2D',
        borderRadius: '24px',
        boxShadow: '0 8px 32px rgba(255, 215, 0, 0.15)',
        transition: 'all 0.3s ease',
        '&:hover': {
          border: '1px solid #FFD700',
          boxShadow: '0 12px 48px rgba(255, 215, 0, 0.25)',
        }
      }}>
{/* Cafe Logo & Header */}
<Box sx={{ textAlign: 'center', mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
  {/* Reto Cafe Circular Logo - Black & Yellow Version */}
          <Box
  sx={{
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    height: "70px",
    maxHeight: "70px",
    width: "100px",
    "&:hover": {
      transform: "scale(1.05) rotate(2deg)",
      transition: "transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
      filter: "drop-shadow(0 0 12px rgba(255, 215, 0, 0.8))"
    }
  }}
  onClick={() => navigate("/")}
>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 120 120"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="mainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="50%" stopColor="#FFA500" />
        <stop offset="100%" stopColor="#FF6347" />
      </linearGradient>
      
      <radialGradient id="centerGlow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFD700" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#FF4500" stopOpacity="0" />
      </radialGradient>
      
      <filter id="glow">
        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
        <feMerge>
          <feMergeNode in="coloredBlur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>

    {/* 3D outer ring */}
    <circle
      cx="60"
      cy="60"
      r="56"
      fill="none"
      stroke="url(#mainGradient)"
      strokeWidth="3"
      filter="url(#glow)"
    />
    <circle
      cx="60"
      cy="60"
      r="53"
      fill="none"
      stroke="rgba(255, 215, 0, 0.3)"
      strokeWidth="2"
    />
    
    {/* Inner background with gradient */}
    <circle cx="60" cy="60" r="47" fill="url(#centerGlow)" />
    <circle cx="60" cy="60" r="44" fill="#0F0F0F" />
    
    {/* Currency/Coin Icon */}
    <g transform="translate(52, 40)">
      {/* Coin circle */}
      <circle cx="8" cy="1" r="12" fill="none" stroke="#FFD700" strokeWidth="1.2" />
      {/* Dollar sign */}
      <text x="8" y="5" textAnchor="middle" fontSize="9" fontWeight="bold" fill="#FFD700" fontFamily="monospace">$</text>
    </g>
    
    {/* JOMLA text */}
    <text
      x="60"
      y="72"
      textAnchor="middle"
      fontSize="18"
      fontWeight="800"
      fill="#FFD700"
      fontFamily="'Montserrat', 'Poppins', sans-serif"
      letterSpacing="1.5"
      stroke="#FF4500"
      strokeWidth="0.5"
      paintOrder="stroke"
    >
      JOMLA
    </text>
    
    {/* LINE text */}
    <text
      x="60"
      y="92"
      textAnchor="middle"
      fontSize="15"
      fontWeight="600"
      fill="#FFA500"
      fontFamily="'Montserrat', sans-serif"
      letterSpacing="1.8"
      stroke="#D32F2F"
      strokeWidth="0.3"
      paintOrder="stroke"
    >
      LINE
    </text>
    
    {/* Accent lines */}
    <line x1="35" y1="78" x2="45" y2="78" stroke="#FFD700" strokeWidth="1" strokeOpacity="0.5" />
    <line x1="75" y1="78" x2="85" y2="78" stroke="#FFD700" strokeWidth="1" strokeOpacity="0.5" />
  </svg>
</Box>
  <Typography variant="body1" sx={{ color: '#B3B3B3',marginTop:3 }}>
    
    {language === 'ar' ? 'تسجيل الدخول إلى حسابك' : 'Login to account'}
  </Typography>
</Box>        
        {error && (
          <Alert 
            severity="error" 
            sx={{ 
              mb: 3,
              backgroundColor: 'rgba(255, 61, 0, 0.1)',
              color: '#FF3D00',
              border: '1px solid #FF3D00',
              borderRadius: '12px',
              '& .MuiAlert-icon': {
                color: '#FF3D00',
              }
            }}
          >
            {error}
          </Alert>
        )}
        
        {/* Google Login Button */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleGoogleLogin}
          disabled={loading}
          startIcon={<GoogleIcon />}
          sx={{ 
            mb: 3, 
            py: 1.8,
            backgroundColor: '#1A1A1A',
            color: '#FFFFFF',
            border: '1px solid #2D2D2D',
            borderRadius: '12px',
            fontWeight: 700,
            fontSize: '1.1rem',
            '&:hover': {
              backgroundColor: '#FFD700',
              color: '#000000',
              borderColor: '#FFD700',
              boxShadow: '0 6px 16px rgba(255, 215, 0, 0.3)',
            },
            transition: 'all 0.2s ease'
          }}
        >
          {language === 'ar' ? 'المتابعة عبر جوجل' : 'Continue with google'}
        </Button>

        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          mb: 3,
          gap: 1
        }}>
          <Divider sx={{ 
            flex: 1,
            backgroundColor: '#2D2D2D',
            height: '1px'
          }} />
          <Chip 
            label={language === 'ar' ? "أو" : "OR"}
            sx={{
              backgroundColor: '#1A1A1A',
              color: '#B3B3B3',
              border: '1px solid #2D2D2D',
              borderRadius: '8px',
              fontWeight: 600
            }}
          />
          <Divider sx={{ 
            flex: 1,
            backgroundColor: '#2D2D2D',
            height: '1px'
          }} />
        </Box>

        {/* Email/Password Form */}
        <Box component="form" onSubmit={handleSubmit}>
          {/* Email Field */}
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ 
              color: '#B3B3B3', 
              fontSize: '0.9rem',
              mb: 1,
              textAlign:'left' 
            }}> 
              {language === 'ar' ? 'البريد الإلكتروني' : 'E-mail'}
            </Typography>
            <TextField
              fullWidth
              placeholder={language === 'ar' ? 'أدخل بريدك الإلكتروني' : 'Enter E-mail'}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#1A1A1A',
                  color: '#FFFFFF',
                  borderRadius: '12px',
                  '& fieldset': {
                    borderColor: '#2D2D2D',
                  },
                  '&:hover fieldset': {
                    borderColor: '#FFD700',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#FFD700',
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#6B6B6B',
                  opacity: 1,
                },
                '& .Mui-disabled': {
                  backgroundColor: '#0D0D0D',
                  '& fieldset': {
                    borderColor: '#2D2D2D',
                  }
                }
              }}
            />
          </Box>

          {/* Password Field */}
          <Box sx={{ mb: 4 }}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              mb: 1
            }}>
              <Typography sx={{ 
                color: '#B3B3B3', 
                fontSize: '0.9rem',
                textAlign:'right'
              }}>
                {language === 'ar' ? 'كلمة المرور' : 'Password'}
              </Typography>
              <Button 
                component="a" 
                href="/forgot-password"
                sx={{
                  color: '#B3B3B3',
                  fontSize: '0.8rem',
                  textTransform: 'none',
                  '&:hover': {
                    color: '#FFD700',
                    backgroundColor: 'transparent',
                  }
                }}
              >
                {language === 'ar' ? 'نسيت كلمة المرور؟' : 'Forget Password ?'}
              </Button>
            </Box>
            <TextField
              fullWidth
              placeholder={language === 'ar' ? 'أدخل كلمة المرور' : 'Enter Password'}
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
              InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: '#B3B3B3' }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{ color: '#B3B3B3' }}
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#1A1A1A',
                  color: '#FFFFFF',
                  borderRadius: '12px',
                  '& fieldset': {
                    borderColor: '#2D2D2D',
                  },
                  '&:hover fieldset': {
                    borderColor: '#FFD700',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#FFD700',
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#6B6B6B',
                  opacity: 1,
                },
                '& .Mui-disabled': {
                  backgroundColor: '#0D0D0D',
                }
              }}
            />
          </Box>

          {/* Login Button */}
          <Button 
            type="submit" 
            variant="contained" 
            fullWidth 
            disabled={loading}
            startIcon={<LoginIcon />}
            sx={{ 
              py: 1.8,
              backgroundColor: '#FFD700',
              color: '#000000',
              fontWeight: 800,
              fontSize: '1.1rem',
              borderRadius: '12px',
              border: '1px solid #FFD700',
              '&:hover': {
                backgroundColor: '#FFE55C',
                boxShadow: '0 6px 20px rgba(255, 215, 0, 0.4)',
                transform: 'translateY(-2px)'
              },
              '&.Mui-disabled': {
                backgroundColor: '#2D2D2D',
                color: '#6B6B6B',
                border: '1px solid #2D2D2D',
              },
              transition: 'all 0.2s ease'
            }}
          >
            {loading ? prossessLoginTxt : loginTxt}
          </Button>
        </Box>
        
        {/* Register Link */}
        <Box sx={{ 
          mt: 4, 
          pt: 3, 
          textAlign: 'center',
          borderTop: '1px solid #2D2D2D'
        }}>
          <Typography variant="body1" sx={{ color: '#B3B3B3', display: 'inline' }}>
            {language === 'ar' ? 'لا تمتلك حساب؟' : 'Dont have account ?'}{' '}
          </Typography>
          <Button 
            component="a" 
            href="/register"
            sx={{
              color: '#FFD700',
              fontWeight: 700,
              fontSize: '1rem',
              textTransform: 'none',
              minWidth: 'auto',
              '&:hover': {
                backgroundColor: 'rgba(255, 215, 0, 0.08)',
                textDecoration: 'underline',
              }
            }}
          >
            {language === 'ar' ? 'سجل من هنا' : 'Register here'} 
          </Button>
        </Box>

        {/* Welcome Back Message */}
        <Box sx={{ 
          mt: 3,
          p: 2,
          backgroundColor: 'rgba(255, 215, 0, 0.05)',
          borderRadius: '12px',
          border: '1px solid #2D2D2D',
          textAlign: 'center'
        }}>
          <Typography variant="body2" sx={{ color: '#B3B3B3' }}>
            {language === 'ar' ? '☕ مرحباً بعودتك! استمتع بتجربة تسوق استثنائية' : '☕ Welcome back! Contains light shopping varieties'}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginPage;